import { render, staticRenderFns } from "./NutrientModal2.vue?vue&type=template&id=c932edb6&scoped=true"
import script from "./NutrientModal2.vue?vue&type=script&lang=js"
export * from "./NutrientModal2.vue?vue&type=script&lang=js"
import style0 from "./NutrientModal2.vue?vue&type=style&index=0&id=c932edb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c932edb6",
  null
  
)

export default component.exports